import React, { useRef, useState } from 'react'
import { DynamicEntityIndex, FlashMessage, Modal, ModalAlert } from '@reactiveonline/reactive_admin_shared-packages'
import { dynamicTableItemRenderer, truncateString } from '@reactiveonline/reactive_admin_shared-packages/utils'

const offlineErrorLogsTableHeadings = [
  { key: 'error',            label: 'error'          },
  { key: 'body',             label: 'body'           },
  { key: 'created_at',       label: 'createdAt'      },
]

export default function TechnicalTab({
  destroyErrorLogPath, offlineErrorLogsPath, setLoading, submitRevisedOfflineTransactionBodyPath
}) {
  const [offlineErrorLogs, setOfflineErrorLogs]                           = useState([])
  const [currentlySelectedErrorLogBody, setCurrentlySelectedErrorLogBody] = useState(null)
  const [currentlySelectedErrorLogId, setCurrentlySelectedErrorLogId]     = useState(null)
  const [errorLogToBeDeletedId, setErrorLogToBeDeletedId]                 = useState(null)
  const [showDataModal, setShowDataModal]                                 = useState(false)
  const [showSubmitAlert, setShowSubmitAlert]                             = useState(false)
  const [renderKey, setRenderKey]                                         = useState(1)

  const flashMessageRef = useRef(null)

  const actions = [
    { onClick: (e, item) => { e.preventDefault(); setErrorLogToBeDeletedId(item.id) }, icon: 'fa-trash' }
  ]

  const offlineErrorsItemRenderer = (item, columns) => {
    return (
      <>
        { columns.map( column => {
          if (column.label === 'error') {
            return (
              <div key={ column.label } className='item flex-1'>
                { truncateString(item[column.label], 30) }
                { item[column.label] && item[column.label].length > 30 &&
                  <i className='pointer m-l-10 m-r-10 fa-light fa-square-info' onClick={ ()=> setShowDataModal(item[column.label]) } />
                }
              </div>
            )
          } else if (column.label === 'body') {
            return (
              <div key={ column.label } className='item flex-1'>
                { truncateString(item[column.label], 30) }
                { item[column.label] && item[column.label].length > 30 &&
                  <i
                    className='pointer m-l-10 m-r-10 fa-light fa-pencil'
                    onClick={ ()=> { setCurrentlySelectedErrorLogBody(JSON.stringify(JSON.parse(item.body), null, 2)); setCurrentlySelectedErrorLogId(item.id) } }
                  />
                }
              </div>
            )
          } else {
            return dynamicTableItemRenderer(item, column)
          }
        })}
      </>
    )
  }

  const handleSubmitRevisedBody = _ => {
    const fd = new FormData()

    fd.append('data', currentlySelectedErrorLogBody)
    fd.append('error_log_id', currentlySelectedErrorLogId)

    setShowSubmitAlert(false)
    setCurrentlySelectedErrorLogBody(null)
    setCurrentlySelectedErrorLogId(null)
    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: submitRevisedOfflineTransactionBodyPath,
      data: fd,
      dataType: 'json',
      success: res => {
        setLoading(false)
        setRenderKey(Math.random())
        flashMessageRef.current.show(res.message)
      },
      error: res => {
        setLoading(false)
        setRenderKey(Math.random())
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  const handleDestroyErrorLog = _ => {
    const fd = new FormData()

    fd.append('error_log_id', errorLogToBeDeletedId)

    setLoading(true)
    setErrorLogToBeDeletedId(null)
    
    Rails.ajax({
      type: 'POST',
      url: destroyErrorLogPath,
      data: fd,
      dataType: 'json',
      success: res => {
        setLoading(false)
        setRenderKey(Math.random())
        flashMessageRef.current.show(res.message)
      },
      error: res => {
        setLoading(false)
        setRenderKey(Math.random())
        flashMessageRef.current.show(res.error, 'error')
      }
    })
  }

  return (
    <>
      <div>
        <DynamicEntityIndex
          key={ renderKey }
          initialItems={ offlineErrorLogs }
          setInitialItems={ setOfflineErrorLogs }
          disableCustomization
          disableSearch
          disableDelete
          tableHeadings={ offlineErrorLogsTableHeadings }
          itemRenderer={ offlineErrorsItemRenderer }
          itemsPath={ offlineErrorLogsPath }
          icon='fa-bomb'
          noResourcesTitle={ Support.translations.account.no_offline_error_logs }
          listColumns={ offlineErrorLogsTableHeadings }
          columnTranslations={ Support.translations.columns }
          fetchOnStart
          disableUrlUpdates
          headline={ Support.translations.account.offline_error_logs }
          initialTotalCount={ 0 }
          actions={ actions }
        />
      </div>

      { !!currentlySelectedErrorLogBody && 
        <Modal
          visible
          mode='large'
          action={ () => setShowSubmitAlert(true) }
          actionText={ Support.translations.submit }
          closeModal={ () => { setCurrentlySelectedErrorLogBody(null); setCurrentlySelectedErrorLogId(null) } }
          wrapperStyles={{ height: '100%' }}
        >
          <div className='m-t-30' style={{ height: '100%' }}>
            <textarea
              type='text'
              value={ currentlySelectedErrorLogBody }
              onChange={ e => setCurrentlySelectedErrorLogBody(e.target.value) }
              style={{ height: '100%' }}
            />
          </div>
        </Modal>
      }

      { showDataModal &&
        <Modal
          visible
          mode='medium'
          action={ ()=> setShowDataModal(false) }
          actionText={ ReactiveCore.translations.close_action }
          closeModal={ ()=> setShowDataModal(false) }
        >
          <div className='m-t-30'>
            { showDataModal }
          </div>
        </Modal>
      }

      { showSubmitAlert &&
        <ModalAlert
          alert={ 'You are about to submit this body to oxygen. Are you sure you want to proceed?' }
          onSelect={ handleSubmitRevisedBody }
          onClose={ ()=> setShowSubmitAlert(false) }
        />
      }

      { errorLogToBeDeletedId &&
        <ModalAlert
          alert={ Support.translations.destroy_error_log_alert }
          onSelect={ handleDestroyErrorLog }
          onClose={ ()=> setErrorLogToBeDeletedId(null) }
        />
      }

      <FlashMessage ref={ flashMessageRef } />
    </>
  )
}